import React from "react";
import useSWR, { mutate } from "swr";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/app/PageHeader";
import { toast } from "sonner";
import { TimeEntryForm } from "@/components/app/TimeEntryForm";
import { TimeEntryList } from "@/components/app/TimeEntryList";

const fetcher = (u) => api.get(u).then((r) => r.data);

const todayISO = () => new Date().toISOString().slice(0, 10);

function computeTotals(entries) {
  const t = { total: 0 };
  for (const e of entries) { t[e.category] = (t[e.category] || 0) + e.hours; t.total += e.hours; }
  return t;
}

export default function TimeTracking() {
  const [form, setForm] = React.useState({
    date: todayISO(), category: "facturable", hours: "", mission_id: "",
    client_id: "", description: "",
  });
  const [filterFrom, setFilterFrom] = React.useState(() => {
    const d = new Date(); d.setDate(1); return d.toISOString().slice(0, 10);
  });
  const [filterTo, setFilterTo] = React.useState(todayISO());

  const { data: missions = [] } = useSWR("/missions", fetcher);
  useSWR("/clients", fetcher);
  const key = `/time-entries?date_from=${filterFrom}&date_to=${filterTo}`;
  const { data: entries = [] } = useSWR(key, fetcher);

  const missionMap = Object.fromEntries(missions.map((m) => [m.id, m]));
  const totals = computeTotals(entries);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        date: form.date, category: form.category, hours: parseFloat(form.hours),
        mission_id: form.mission_id || null, client_id: form.client_id || null,
        description: form.description || null,
      };
      await api.post("/time-entries", payload);
      toast.success("Temps enregistré");
      setForm({ ...form, hours: "", description: "" });
      mutate(key);
    } catch { toast.error("Impossible d'enregistrer"); }
  };

  const del = async (id) => {
    try { await api.delete(`/time-entries/${id}`); mutate(key); }
    catch (err) { toast.error(err?.response?.data?.detail || "Suppression impossible"); }
  };

  return (
    <div>
      <PageHeader eyebrow="Gestion" title="Suivi du temps" description="Saisie journalière — facturable, administratif, commercial, formation, absence." />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <TimeEntryForm form={form} setForm={setForm} missions={missions} missionMap={missionMap} onSubmit={submit} />
        <TimeEntryList
          entries={entries}
          totals={totals}
          missionMap={missionMap}
          filterFrom={filterFrom} filterTo={filterTo}
          setFilterFrom={setFilterFrom} setFilterTo={setFilterTo}
          onDelete={del}
        />
      </div>
    </div>
  );
}
